import { animate, state, style, transition, trigger } from "@angular/animations";
import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from "@angular/core";

import { CustomIconComponent } from "@shared/components/custom-icon/custom-icon.component";
import { Toast, ToastService } from "@shared/services/toast.service";

@Component({
  selector: "component-toast",
  imports: [CustomIconComponent],
  templateUrl: "./toast.component.html",
  styleUrls: ["./toast.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("toastAnimation", [
      state(
        "void",
        style({
          transform: "translateX(100%)",
          opacity: 0,
          height: 0,
          marginBottom: 0,
          padding: 0,
          overflow: "hidden"
        })
      ),
      state(
        "*",
        style({
          transform: "translateX(0)",
          opacity: 1,
          height: "*",
          marginBottom: "0.5rem",
          overflow: "hidden"
        })
      ),
      transition("void => *", [
        style({
          height: "*",
          marginBottom: "0.5rem",
          padding: "*"
        }),
        animate(
          "200ms ease-out",
          style({
            transform: "translateX(0)",
            opacity: 1
          })
        )
      ]),
      transition("* => void", [
        animate(
          "200ms ease-in",
          style({
            transform: "translateX(100%)",
            opacity: 0
          })
        ),
        animate(
          "150ms ease-out",
          style({
            height: 0,
            marginBottom: 0,
            padding: 0
          })
        )
      ])
    ])
  ]
})
export class ToastComponent implements OnInit {
  readonly toasts = signal<Toast[]>([]);
  private readonly _toastService = inject(ToastService);

  ngOnInit(): void {
    this._toastService.getToasts().subscribe((toasts) => {
      this.toasts.set(toasts);
    });
  }

  removeToast(id: number): void {
    this._toastService.remove(id);
  }

  getToastColor(toast: Toast): string {
    switch (toast.type) {
      case "success":
        return "var(--success-color)";
      case "error":
        return "var(--danger-color)";
      case "warning":
        return "var(--warning-color)";
      case "info":
        return "var(--primary-color)";
      default:
        return "var(--text-color)";
    }
  }

  getToastIcon(toast: Toast): string {
    switch (toast.type) {
      case "success":
        return "checkCircleFilled";
      case "error":
        return "closeCircleFilled";
      case "warning":
        return "triangleAlert";
      case "info":
        return "bell";
      default:
        return "bell";
    }
  }
}
